// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signatures__table[data-v-f823b146] {\n  margin-top: 20px;\n}\n.signatures__doc-table[data-v-f823b146] {\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
